import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import ESP from '../../../../node_modules/error-stack-parser';
import { AuditService } from '../api/services/audit.service';
import { ConsoleService } from './console.service';

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  protected onDestroy$ = new Subject<void>();

  constructor(private auditService: AuditService) {}

  logError(className: string, error: any, eventType) {
    this.unSubs();
    ConsoleService.error('error is', error.message + ' [' + className + '] ');
    return;
    // if (environment.apiUrl == 'https://smspaneldev.pishgamrayan.com') {
    //   let model: logDetailDto = {};
    //   model.className = className;
    //   model.message = error.message;
    //   model.detail = ESP.parse(error).slice(0, 2).toString();
    //   let data = JSON.stringify(model)
    //   this.auditService.auditCreateFrontEndLog
    //     ({ body: { data: data, eventType: eventType } })
    //     .pipe(takeUntil(this.onDestroy$)).subscribe()

    ConsoleService.info('tagName', className);
    ConsoleService.info('message', error.message);
    ConsoleService.info('detail', ESP.parse(error).slice(0, 2));
    ConsoleService.info('eventType', eventType);
    // }
  }

  unSubs() {
    this.onDestroy$.next();
  }
}

class logDetailDto {
  className?: string;
  message?: string;
  detail?: string;
}
